
var clientSideValidation = require('./clientSideValidation');

var $loginForm = $('form.login .g-recaptcha');
var $checkoutForm = $('#checkout-form');
var $checkoutButton = $('.checkout-btn.g-recaptcha');
var $resetFormButton = $('form.reset-password-form .g-recaptcha');

window.onSubmitCaptcha = function(token) {
    $(document).ready(function () {
        var $submitForm = $('form.registration');
        var $gCaptchaInput = $('.g-recaptcha-token')
        $($gCaptchaInput).val(token);
        $($submitForm).submit(); 
    });
}

window.onsubmitCaptchaLogin = function (token) {
    $(document).ready(function () {
        var $form = $('form.login');

        var isValid = clientSideValidation.checkMandatoryField($form);
        if (typeof isValid === 'undefined') {
            isValid = !$form.find('input.is-invalid, select.is-invalid, .form-group.is-invalid').length;
        }

        if (!isValid) {
            return;
        }

        var $gCaptchaInput = $('.g-recaptcha-token');
        $gCaptchaInput.val(token);
        $form.submit();
    });
}

window.onsubmitCaptchaPasswordReset = function (token) {
    $(document).ready(function () {
        var $resetForm = $('form.reset-password-form');
        var $gCaptchaInput = $('.g-recaptcha-token');
        $gCaptchaInput.val(token);
        $resetForm.submit();
    });
};


window.onsubmitCaptchaCheckout = function (token) {
    $(document).ready(function () {
        if ($checkoutForm.length && !$checkoutButton.prop('disabled')) {
            $('.g-recaptcha-token').val(token);
            $checkoutForm.submit();
        }
    });
};

window.onsubmitCaptchaIBCPostalSearch = function (token) {
    $(document).ready(function () {
        var $ibcForm = $('form.ibcsearch-postalcode');
        var $gCaptchaInput = $('.g-recaptcha-token');
        $gCaptchaInput.val(token);
        $ibcForm.submit();
    });
};

window.onsubmitCaptchaIBCNameSearch = function (token) {
    $(document).ready(function () {
        var $ibcForm = $('form.ibcsearch-name');
        var $gCaptchaInput = $('.g-recaptcha-token');
        $gCaptchaInput.val(token);
        $ibcForm.submit();
    });
};

window.onsubmitCaptchaIBCPhoneSearch = function (token) {
    $(document).ready(function () {
        var $ibcPhoneForm = $('form.ibcsearch-phone');
        var $gCaptchaInput = $('.g-recaptcha-token');
        $gCaptchaInput.val(token);
        $ibcPhoneForm.submit();
    });
};

window.onsubmitEnroll = function (token) {
    $(document).ready(function () {
        var $ibcPhoneForm = $('form.email-signup-form');
        var $gCaptchaInput = $('.g-recaptcha-token');
        $gCaptchaInput.val(token);
        $ibcPhoneForm.submit();
    });
};

if ($loginForm.length === 1) {
    $('#login-form-email, #login-form-password').on('keydown', function (event) {
        if (event.which === 13) {
            event.preventDefault();
            $loginForm.click();
            
        }
    });
}

if ($resetFormButton.length === 1) {
    $('#reset-password-email').on('keydown', function (event) {
        if (event.which === 13) {
            event.preventDefault();
            $resetFormButton.click();
        }
    });
}

// Use event delegation for dynamically loaded IBC search form
$(document).on('keydown', 'form.ibcsearch-name #firstName, form.ibcsearch-name #lastName', function (event) {
    if (event.which === 13) {
        event.preventDefault();
        var $ibcForm = $(event.currentTarget).closest('form.ibcsearch-name');
        var $ibcSearchButton = $ibcForm.find('.g-recaptcha');
        if ($ibcSearchButton.length > 0) {
            $ibcSearchButton.click();
        } else {
            $ibcForm.trigger('submit');
        }
    }
});

/**
 * Callback function for Google reCAPTCHA on checkout shipping submission
 * Populates hidden token field and triggers shipping submission
 * @param {string} token - The reCAPTCHA token from Google
 */
window.onsubmitCaptchaShipping = function (token) {
    $(document).ready(function () {
        var $gCaptchaInput = $('#grecaptchatoken-checkout');
        var $submitButton = $('.submit-shipping.g-recaptcha');

        // Populate hidden token field
        $gCaptchaInput.val(token);

        // Temporarily remove g-recaptcha class to prevent re-triggering
        $submitButton.removeClass('g-recaptcha');

        // Trigger the existing shipping submission handler
        $submitButton.click();

        // Re-add g-recaptcha class for potential future clicks
        setTimeout(function () {
            $submitButton.addClass('g-recaptcha');
        }, 100);
    });
};

/**
 * Callback function for Google reCAPTCHA on checkout delivery submission
 * Populates hidden token field and triggers delivery method submission
 * @param {string} token - The reCAPTCHA token from Google
 */
window.onsubmitCaptchaDelivery = function (token) {
    $(document).ready(function () {
        var $gCaptchaInput = $('#grecaptchatoken-checkout');
        var $submitButton = $('.submit-delivery.g-recaptcha');

        // Populate hidden token field
        $gCaptchaInput.val(token);

        // Temporarily remove g-recaptcha class to prevent re-triggering
        $submitButton.removeClass('g-recaptcha');

        // Trigger the existing delivery method submission handler
        $submitButton.click();

        // Re-add g-recaptcha class for potential future clicks
        setTimeout(function () {
            $submitButton.addClass('g-recaptcha');
        }, 100);
    });
};

/**
 * Callback function for Google reCAPTCHA on checkout e-invoice submission
 * Populates hidden token field and triggers e-invoice submission
 * @param {string} token - The reCAPTCHA token from Google
 */
window.onsubmitCaptchaEInvoice = function (token) {
    $(document).ready(function () {
        var $gCaptchaInput = $('#grecaptchatoken-checkout');
        var $submitButton = $('.submit-e-invoice.g-recaptcha');

        // Populate hidden token field
        $gCaptchaInput.val(token);

        // Temporarily remove g-recaptcha class to prevent re-triggering
        $submitButton.removeClass('g-recaptcha');

        // Trigger the existing e-invoice submission handler
        $submitButton.click();

        // Re-add g-recaptcha class for potential future clicks
        setTimeout(function () {
            $submitButton.addClass('g-recaptcha');
        }, 100);
    });
};
